module.exports = __webpack_public_path__ + "static/img/problem.be1883a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/specialist/problem.png
// module id = 9vfw
// module chunks = 1